<footer class="mt-3">
  <div class="bottom-footer p-4 d-flex flex-column flex-md-row justify-content-center align-items-center text-white">
    <div class="content-container align-self-center">
      <p class="mb-2">
        Uniara - Universidade de Araraquara / Rua Carlos Gomes, 1338, Centro / Araraquara-SP / CEP 14801-340 / 16 3301.7100 (Geral) / 0800 55 65 88 (Vestibular)
      </p>
      <ul class="footer-info list-unstyled d-flex justify-content-center mb-0">
        <li>
          <button class="btn btn-link text-white" type="button" (click)="openCookieSettings()" role="button" tabindex="0">
            {{ 'footer.link.cookies' | translate}}
          </button>
        </li>
        <li>
          <a class="btn text-white"
             routerLink="info/accessibility" role="link" tabindex="0">{{ 'footer.link.accessibility' | translate }}</a>
        </li>
        <li>
          <a class="btn text-white"
          routerLink="info/feedback" role="link" tabindex="0">{{ 'footer.link.feedback' | translate}}</a>
        </li>
      </ul>
    </div>
  </div>
</footer>